import React, {useState} from "react";
import {Card, Col, Row, Select, Space} from "antd";
import ReligionVenueCard from "../../containers/vscs/ReligionVenueCard";
import {useMount} from "ahooks";
import {ApiService} from "../../services/ApiService";
import {CommonApi} from "../../services/CommonApi";
import {VscsApi} from "../../services/VscsApi";
import {useNavigate} from "react-router-dom";

const {Option} = Select;

let searchOptions = {}

const VscsReligionVenueListPage = () => {
    const navigate = useNavigate()
    const [religions, setReligions] = useState([])
    const [regions, setRegions] = useState([])
    const [venues, setVenues] = useState([])

    const requestVenues = () => {
        VscsApi.venues(searchOptions.region, searchOptions.religion)
            .onSuccess(setVenues)
    }

    useMount(() => {
        ApiService.constants.religion()
            .onSuccess(data => {
                setReligions([...data])
            })
        CommonApi.regionChildrenLimit(3)
            .onSuccess(regions => {
                setRegions([...regions])
            })
        requestVenues()
    })

    function onChange(key, value) {
        searchOptions[key] = value
        requestVenues()
    }

    return (
        <>
            <Card
                extra={
                    <Space>
                        <Select
                            showSearch
                            placeholder="按地区筛选"
                            optionFilterProp="children"
                            defaultValue={searchOptions.region}
                            onChange={value => onChange('region', value)}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {
                                regions.map(r => <Option value={r.code}>{r.name}</Option>)
                            }
                        </Select>
                        <Select
                            showSearch
                            placeholder="按宗教类型筛选"
                            optionFilterProp="children"
                            defaultValue={searchOptions.religion}
                            onChange={value => onChange('religion', value)}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            <Option value="-1">全部</Option>
                            {
                                religions.map(r => <Option value={r.value}>{r.name}</Option>)
                            }
                        </Select>
                    </Space>
                }>
                <Row>
                    {
                        venues.map(v => <Col xs={12} md={8} lg={6} xl={4}>
                            <ReligionVenueCard
                                onClick={() => navigate('/vscs/venue?id=' + v.guid)}
                                key={v.guid}
                                imageUrl={v.imageUrl}
                                name={v.name}
                                region={v.properties?.region?.name}
                                religion={v.properties?.religion}
                            />
                        </Col>)
                    }
                </Row>
            </Card>
        </>
    )
}

export default VscsReligionVenueListPage